module.exports = __webpack_public_path__ + "static/media/mode-560.9b7961b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-560.svg
// module id = 1077
// module chunks = 2